import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { client, urlFor, blogQueries } from '../sanityClient'
import './blog-list.css'

const BlogList = () => {
  const [blogPosts, setBlogPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        setLoading(true)
        const posts = await client.fetch(blogQueries.getAllPosts)
        setBlogPosts(posts)
        setError(null)
        if (typeof window !== 'undefined') {
          window.prerenderReady = true
        }
      } catch (err) {
        console.error('Error fetching blog posts:', err)
        setError('Failed to load blog posts. Please try again later.')
      } finally {
        setLoading(false)
      }
    }

    fetchBlogPosts()
  }, [])

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  if (loading) {
    return (
      <div className="blog-list-container">
        <div className="blog-list-loading">
          <div className="loading-spinner"></div>
          <p>Loading blog posts...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="blog-list-container">
        <div className="blog-list-error">
          <h2>Oops! Something went wrong</h2>
          <p>{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="blog-list-container">
      <div className="blog-list-header">
        <h1>Latest Blog Posts</h1>
        <p>Stay updated with the latest insights on SMS marketing and business communication.</p>
      </div>
      
      {blogPosts.length === 0 ? (
        <div className="blog-list-empty">
          <h2>No blog posts yet</h2>
          <p>Check back soon for exciting content about SMS marketing and business growth!</p>
        </div>
      ) : (
        <div className="blog-list-grid">
          {blogPosts.map((post) => (
            <article key={post._id} className="blog-card" data-aos="fade-up">
              <Link to={`/blog/${post.slug.current}`} className="blog-card-link">
                {post.mainImage && (
                  <div className="blog-card-image">
                    <img 
                      src={urlFor(post.mainImage).width(400).height(250).url()} 
                      alt={post.title}
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-card-date">
                      {formatDate(post.publishedAt)}
                    </span>
                    {post.estimatedReadingTime && (
                      <span className="blog-card-reading-time">
                        {post.estimatedReadingTime} min read
                      </span>
                    )}
                  </div>
                  <h2 className="blog-card-title">{post.title}</h2>
                  {post.excerpt && (
                    <p className="blog-card-excerpt">{post.excerpt}</p>
                  )}
                  <div className="blog-card-read-more">
                    Read More →
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      )}
    </div>
  )
}

export default BlogList 